import { t as msg } from "../lib/i18n";
import { useId, type ReactNode } from "react";
import { Modal } from "./Modal";

export function ConfirmDialog({
  title,
  children,
  busy,
  onConfirm,
  onCancel,
  confirmLabel = msg("Revoke card"),
  cancelLabel = msg("Keep the promise"),
  destructive = true,
}: {
  title: string;
  confirmLabel?: string;
  cancelLabel?: string;
  destructive?: boolean;
  children: ReactNode;
  busy: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}) {
  const titleId = useId();
  return (
    <Modal
      className="modal confirm-box"
      labelledBy={titleId}
      busy={busy}
      onDismiss={onCancel}
    >
      <h2 id={titleId}>{title}</h2>
      <p>{children}</p>
      <div className="inline-links">
        <button className={destructive ? "button danger" : "button"} disabled={busy} onClick={onConfirm}>
          {busy ? msg("Working…") : confirmLabel}
        </button>
        <button
          data-autofocus
          className="text-button"
          disabled={busy}
          onClick={onCancel}
        >
          {cancelLabel}
        </button>
      </div>
    </Modal>
  );
}
